import DealerModel from '../../models/dealer';
import { lzGetFromLocalStorage, lzSaveToLocalStorage } from '../../services/LzLocalStorage';
import { actions } from '../actions';

const defaultState = {
    // Logged in dealer object
    dealer: new DealerModel(lzGetFromLocalStorage('authDealer')),

    // Logged in dealer token
    token: lzGetFromLocalStorage('authToken'),

    // Loaded fresh data for this window or not
    loaded: false,

    // Remember dealer login or not
    remember: lzGetFromLocalStorage('remember', false),

    // Verification code variable used to auto-pick from mobile sms and fill the form field
    code: '',
};

const auth = (state = defaultState, action) => {

    switch (action.type) {

        case actions.SET_AUTH_DEALER:
            lzSaveToLocalStorage('authDealer', action.remember ? action.value : '');
            return Object.assign({}, state, { dealer: action.value });

        case actions.SET_AUTH_TOKEN:
            lzSaveToLocalStorage('authToken', action.remember ? action.value : '');
            return Object.assign({}, state, { token: action.value });

        case actions.SET_AUTH_LOADED:
            return Object.assign({}, state, { loaded: action.value });

        case actions.SET_AUTH_REMEMBER:
            lzSaveToLocalStorage('remember', action.value);
            return Object.assign({}, state, { remember: action.value });

        default:
            return state;

    }

};

export default auth;
